module.exports = __webpack_public_path__ + "static/alice-101514-00493x-9d564573c8e109fc2836f24f6cfaa429.png";